module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Salas-11.9106bf82.png";